// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3RJW3","image":"Header_image__i9_y-","name":"Header_name__3WwGD","info":"Header_info__2uzya","infoRow":"Header_infoRow__1UNZk"};